export const statusMap = {
    'shortstaffed': 'Short-staffed',
    'equipmentIssues': 'Equipment issues',
    'maintenance': 'Maintenance',
    'outOfService': 'Out of service',
    'functional': 'Functional',
    'pto': 'PTO',
    'training': 'Training',
    'active': 'Active',
    'sick': 'Sick',
    'inactive': 'Inactive',
    'pending': 'Pending',
    'denied': 'Denied',
    'approved': 'Approved',
    'routineMaintenance': 'Routine maintenance',
    'mechanicalFailure': 'Mechanical failure',
    'warranty': 'Warranty/Recall',
    'accident': 'Accident',
    'dotViolation': 'DOT Violation',
    'safetyIssue': 'Safety Issue',
    'unavailable': 'Unavailable',
    'ready': 'Ready',
    'not_ready': 'Not Ready',
    'teamEvent': 'Team Event',
    'noReport': 'No Report',
    'teamevent': 'Team Event'
}

export const fieldMap = {
    'model': 'Model',
    'year': 'Year',
    'vin': 'VIN',
    'beaconSerialNumber': 'Beacon Serial Number',
    'locatorSerialNumber': 'Locator Serial Number',
    'screenSerialNumber': 'Screen Serial Number',
    'associatedAsset': 'Associated Asset',
    'mileage': 'Mileage',
    'operationalHours': 'Operational Hours',
    'stateOfRegistration': 'State of Registration',
    'plateNumber': 'Plate Number',
    'dotInspectionDate': 'DOT Inspection Date',
    'registrationExpiration': 'Registration Expiration',
    'notes': 'Notes',
    'unitNumber': 'Unit Number',
    'assignedMember': 'Assigned Member',
    'splicerSerialNumber': 'Splicer Serial Number',
    'cleaverSerialNumber': 'Cleaver Serial Number',
    'exfoOtdrSerialNumber': 'EXFO OTDR Serial Number',
    'exfoOx1SerialNumber': 'EXFO OX1 Serial Number',
    'exfoNineSerialNumber': 'EXFO 945 Serial Number',
    'exfoScopeSerialNumber': 'EXFO Scope Serial Number',
    'aflFiberIdSerialNumber': 'AFL Fiber ID Serial Number',
    'exfoThreecSerialNumber': 'EXFO 352 Serial Number',
    'team': 'Team',
    'deviceSubType': 'Type',
    'dotRegistrationDate': 'DOT Registration Date',
    'make': 'Make',
    'status': 'Status',
    'associate': 'Assigned Member',
    'tSite': 'T-Site',
    'serialNumber': 'Serial Number',
    'dotExpirationDate': 'DOT Expiration Date',
    'iccName': 'ICC Name',
    'fleetName': 'Fleet Name',
    'associatedTeam': 'Team',
    'checklistVerifiedOn': 'Checklist verified on',
    'checklistVerifiedBy': 'Checklist verified by',
    'trailerSerialNumber': "Trailer Serial Number"
  }

export const validEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const capitalizeFirstLetter = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
